import type { AppRouteRecordRaw, AppRouteModule } from '@/router/types';
import {
    PAGE_NOT_FOUND_ROUTE,
    SVG_PREVIEW,
    MODEL_PREVIEW,
} from '@/router/routes/basic';
import Home from './modules/home';
import { PageEnum } from '@/enums/pageEnum';

// 全局获取 modules 文件夹下的 ts 模块
const routeList = getRouterList('all');
export const asyncRoutes = [...routeList];

export const menuRouteList = [Home, ...getRouterList('menu')].sort(
    (a, b) => ((a.meta?.orderNo as any) || 0) - ((b.meta?.orderNo as any) || 0),
);

export const RootRoute: AppRouteRecordRaw = {
    path: '/',
    name: PageEnum.ROOT,
    redirect: '/home',
    meta: {
        title: 'Root',
    },
};

const devRoutes = import.meta.env.MODE === 'development' 
    ? [ SVG_PREVIEW, MODEL_PREVIEW ] 
    : [ SVG_PREVIEW, MODEL_PREVIEW ]
export const basicRoutes = [
    RootRoute,
    ...asyncRoutes,
    ...devRoutes,
    // PAGE_NOT_FOUND_ROUTE,
];

function getRouterList(path: string) {
    // import 不支持变量
    let modules;
    switch (path) {
        case 'all':
            modules = import.meta.glob('./modules/**/*.ts', { eager: true });
            break;
        case 'menu':
            modules = import.meta.glob('./modules/menu/*.ts', { eager: true });
            break;
    }
    // const modules = import.meta.glob(path, { eager: true });
    const routeModuleList: AppRouteModule[] = [];

    Object.keys(modules).forEach((key) => {
        const mod = modules[key].default || {};
        const modList = Array.isArray(mod) ? [...mod] : [mod];
        routeModuleList.push(...modList);
    });

    return routeModuleList || [];
}
